module.exports = __webpack_public_path__ + "static/wouterraateland-7660670d3ba7440853ad1402597bf4d1.jpg";